import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { getOfflineActiveStepNumber2, offlineTransferPhaseData2 } from "../../../../utils";
import { TransferPhasebar } from "../../../ui/TransferPhasebar";

export const OfflineTransferPhaseLayout2 = () => {
  const location = useLocation();

  const [activeStepNumber, setActiveStepNumber] = React.useState<number>(1);

  React.useEffect(() => {
    setActiveStepNumber(getOfflineActiveStepNumber2(location.pathname, activeStepNumber));
  }, [location.pathname]);

  return (
    <div className="flex">
      <TransferPhasebar
        transactionMode="WesternUnion"
        data={offlineTransferPhaseData2}
        activeStepNumber={activeStepNumber}
      />
      <div className="ml-[379px] w-full h-full">
        <Outlet />
      </div>
    </div>
  );
};
